import { Injectable, inject } from '@angular/core';
import {
  ObservatoryRepository,
  OverlayRepository,
  CrossAnalysisRepository,
  KpiRepository,
  DarkModeRepository,
  ChatRepository,
  ChatShareRepository,
  AIModelRepository,
  AIAgentRepository,
  UbigeoRepository,
  LayerRepository,
  MapRepository,
  MenuRepository,
  FocalPointRepository,
  FocalStatRepository,
  FocalLayerRepository,
  DroneTelemetryRepository,
  ArcGisQueryRepository,
  OGCRepository,
  MediationSpaceRepository,
  AgreementRepository,
  InterventionRepository,
  IndicatorRepository,
  PrinterRepository,
  SpatialReferenceRepository,
  GeoperuRepository,
} from '@gishub/infrastructure';
import { ConfigService } from '../../services/config-service';

@Injectable({ providedIn: 'root' })
export class ObservatoryRepositoryProvider {
  readonly instance = new ObservatoryRepository();
}

@Injectable({ providedIn: 'root' })
export class OverlayRepositoryProvider {
  readonly instance = new OverlayRepository();
}

@Injectable({ providedIn: 'root' })
export class CrossAnalysisRepositoryProvider {
  readonly instance = new CrossAnalysisRepository();
}

@Injectable({ providedIn: 'root' })
export class KpiRepositoryProvider {
  readonly instance = new KpiRepository();
}

@Injectable({ providedIn: 'root' })
export class DarkModeRepositoryProvider {
  readonly instance = new DarkModeRepository();
}

@Injectable({ providedIn: 'root' })
export class ChatRepositoryProvider {
  readonly instance = new ChatRepository();
}

@Injectable({ providedIn: 'root' })
export class ChatShareRepositoryProvider {
  readonly instance = new ChatShareRepository();
}

@Injectable({ providedIn: 'root' })
export class UbigeoRepositoryProvider {
  readonly instance = new UbigeoRepository();
}

@Injectable({ providedIn: 'root' })
export class LayerRepositoryProvider {
  readonly instance = new LayerRepository();
}

@Injectable({ providedIn: 'root' })
export class MapRepositoryProvider {
  readonly instance = new MapRepository();
}

@Injectable({ providedIn: 'root' })
export class MenuRepositoryProvider {
  readonly instance = new MenuRepository();
}

@Injectable({ providedIn: 'root' })
export class FocalPointRepositoryProvider {
  readonly instance = new FocalPointRepository();
}

@Injectable({ providedIn: 'root' })
export class FocalStatRepositoryProvider {
  readonly instance = new FocalStatRepository();
}

@Injectable({ providedIn: 'root' })
export class FocalLayerRepositoryProvider {
  readonly instance = new FocalLayerRepository();
}

@Injectable({ providedIn: 'root' })
export class DroneTelemetryRepositoryProvider {
  readonly instance = new DroneTelemetryRepository();
}

/**
 * Proveedor del repositorio de queries ArcGIS.
 * Inyecta el proxyUrl desde ConfigService para que las capas con hasProxy=true
 * usen el proxy al hacer peticiones axios al servidor ArcGIS.
 */
@Injectable({ providedIn: 'root' })
export class ArcGisQueryRepositoryProvider {
  private readonly _config = inject(ConfigService);
  readonly instance = new ArcGisQueryRepository(this._config.proxyUrl);
}

@Injectable({ providedIn: 'root' })
export class OGCRepositoryProvider {
  readonly instance = new OGCRepository();
}

@Injectable({ providedIn: 'root' })
export class GeoperuRepositoryProvider {
  readonly instance = new GeoperuRepository();
}

@Injectable({ providedIn: 'root' })
export class MediationSpaceRepositoryProvider {
  readonly instance = new MediationSpaceRepository();
}

@Injectable({ providedIn: 'root' })
export class AgreementRepositoryProvider {
  readonly instance = new AgreementRepository();
}

@Injectable({ providedIn: 'root' })
export class InterventionRepositoryProvider {
  readonly instance = new InterventionRepository();
}

@Injectable({ providedIn: 'root' })
export class IndicatorRepositoryProvider {
  readonly instance = new IndicatorRepository();
}

@Injectable({ providedIn: 'root' })
export class PrinterRepositoryProvider {
  readonly instance = new PrinterRepository();
}

@Injectable({ providedIn: 'root' })
export class SpatialReferenceRepositoryProvider {
  readonly instance = new SpatialReferenceRepository();
}

@Injectable({ providedIn: 'root' })
export class AIModelRepositoryProvider {
  readonly instance = new AIModelRepository();
}

@Injectable({ providedIn: 'root' })
export class AIAgentRepositoryProvider {
  readonly instance = new AIAgentRepository();
}
